import SubcategoryPage from '@/components/template/SubcategoryPage';

const OrdinaRound = () => {
  const products = [
    {
      title: "Ordina Round Model 1",
      imageSrc: "https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80",
      url: "/ogledala/ordina-round/model-1"
    },
    {
      title: "Ordina Round Model 2",
      imageSrc: "https://images.unsplash.com/photo-1568782987637-963d378332cd?auto=format&fit=crop&q=80",
      url: "/ogledala/ordina-round/model-2"
    },
    {
      title: "Ordina Round Model 3",
      imageSrc: "https://images.unsplash.com/photo-1625591340248-6d472233115c?auto=format&fit=crop&q=80",
      url: "/ogledala/ordina-round/model-3"
    },
    {
      title: "Ordina Round Model 4",
      imageSrc: "https://images.unsplash.com/photo-1654796586436-69130e132ca5?auto=format&fit=crop&q=80",
      url: "/ogledala/ordina-round/model-4"
    }
  ];

  return (
    <SubcategoryPage
      title="Ordina Round"
      description="Minimalistična okrogla ogledala z elegantnim okvirjem. Čiste linije za prefinjene interiere, ki jih odlikuje popoln red."
      heroImage="https://images.unsplash.com/photo-1618220924273-338d82d6b886?auto=format&fit=crop&q=80"
      products={products}
    />
  );
};

export default OrdinaRound;